import FolderRoundedIcon from '@mui/icons-material/FolderRounded';
import { Stack, Typography } from '@mui/material';
import { SimpleTreeView, TreeItem } from '@mui/x-tree-view';
import { DetailResponse } from 'features/lead/lead-management/lead-questionnaire-details/lead-questionnaire-details.types';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

interface Props {
  details: DetailResponse;
}

const LeadQuestions: React.FC<Props> = ({ details }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.questionnaire}>
      <SimpleTreeView>
        {details.closedQuestions.map((category) => (
          <TreeItem className={classes.treeItem} itemId={category.id} key={category.id} label={category.name.de}>
            {category.subCategories.map((subCategory) =>
              subCategory.questions.length > 0 ? (
                <TreeItem itemId={subCategory.id} key={subCategory.id} label={subCategory.name.de}>
                  <Stack className={classes.questions} gap={0.5}>
                    {subCategory.questions.map((question) => (
                      <Stack key={question.id} direction={'row'} alignItems={'center'} gap={2}>
                        <FolderRoundedIcon className={classes.treeIcon} />
                        <Typography className={classes.treeQuestion}>{question.selfAssessment.de}</Typography>
                      </Stack>
                    ))}
                  </Stack>
                </TreeItem>
              ) : null
            )}
          </TreeItem>
        ))}
      </SimpleTreeView>
      {details.effectQuestions.length > 0 && (
        <SimpleTreeView>
          <TreeItem className={classes.treeItem} itemId={'effectQuestions'} label={'Effektive Führung'}>
            {details.effectQuestions.map((subCategory) =>
              subCategory.questions.length > 0 ? (
                <TreeItem className={classes.treeItem} itemId={subCategory.id} key={subCategory.id} label={subCategory.name.de}>
                  <Stack className={classes.questions} gap={0.5}>
                    {subCategory.questions.map((question) => (
                      <Stack key={question.id} direction={'row'} alignItems={'center'} gap={2}>
                        <FolderRoundedIcon className={classes.treeIcon} />
                        <Typography className={classes.treeQuestion}>{question.selfAssessment.de}</Typography>
                      </Stack>
                    ))}
                  </Stack>
                </TreeItem>
              ) : null
            )}
          </TreeItem>
        </SimpleTreeView>
      )}
      {details.openQuestions.length > 0 && (
        <SimpleTreeView>
          <TreeItem className={classes.treeItem} itemId={'openQuestions'} label={'Ihre persönlichen Eindrücke'}>
            <Stack className={classes.questions} gap={0.5}>
              {details.openQuestions.map((question) => (
                <Stack key={question.id} direction={'row'} alignItems={'center'} gap={2}>
                  <FolderRoundedIcon className={classes.treeIcon} />
                  <Typography className={classes.treeQuestion}>{question.selfAssessment.de}</Typography>
                </Stack>
              ))}
            </Stack>
          </TreeItem>
        </SimpleTreeView>
      )}
    </div>
  );
};

const useStyles = makeStyles()((theme) => ({
  questionnaire: {
    maxHeight: 'calc(100% - 19.5px - 32px)',
    width: '100%',
    padding: '16px',
    border: `2px solid ${theme.palette.backgrounds.main}`,
    overflow: 'auto',
  },
  treeItem: {
    color: theme.palette.greys.medium,
    '& .MuiTreeItem-content': {
      marginBottom: '8px',
      padding: '0 8px',
      '&.Mui-selected': {
        background: '#FFF',
      },
    },
    '& .MuiTreeItem-label': {
      fontSize: theme.typography.pxToRem(13),
    },
    '& .MuiCollapse-root': {
      marginLeft: '17px',
    },
  },
  questions: {
    padding: '0 0 8px 12px',
  },
  treeIcon: {
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.greys.medium,
  },
  treeQuestion: {
    fontSize: theme.typography.pxToRem(13),
    color: theme.palette.greys.medium,
  },
}));

export default LeadQuestions;
